<!--
 @description 头部
 @author xiehan
 @date 2018/9/19
-->
<template>
  <div class="app-header">
    <img class="uke-logo"
      src="@/assets/image/base/logo-w.png" />
    <div class="user-info-wrap"
      @mouseenter="userInfoVisible=true"
      @mouseleave="userInfoVisible=false">
      <span v-text="userName"></span>
      <transition name="fade">
        <div class="user-info"
          v-show="userInfoVisible">
          <div class="user-info-each"
            v-text="$t('header.changeUserinfo')"
            @click="handlerUserInfo"></div>
          <div class="user-info-each"
            v-text="$t('header.changePassword')"
            @click="handlerPwdInfo"></div>
          <div class="user-info-each"
            v-text="$t('header.logout')"
            @click="logout"></div>
        </div>
      </transition>
    </div>
    <!-- <div class="user-info-wrap" @mouseenter="langVis=true" @mouseleave="langVis=false">
      <span v-text="langType"></span>
      <span class="uk-icon-arrow-down"></span>
      <transition name="fade">
        <div class="lang-info" v-show="langVis">
          <div class="user-info-each" v-text="'简体中文'" @click="setLangType('zh')"></div>
          <div class="user-info-each" v-text="'English'" @click="setLangType('en')"></div>
        </div>
      </transition>
    </div> -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('header.changeUserinfo')"
      :visible.sync="dialogVisible"
      width="400px">
      <el-form label-position="right"
        label-width="80px"
        :model="userInfo"
        ref="userInfoForm"
        :rules="userInfoRule">
        <el-form-item :label="$t('header.userName')">
          <el-input v-model="userInfo.userName"
            :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.name')"
          prop="realName">
          <el-input v-model="userInfo.realName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.phoneNum')"
          prop="phoneNum">
          <el-input v-model.number="userInfo.phoneNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.email')"
          prop="email">
          <el-input v-model="userInfo.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisible=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
          @click="confirmChange">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :closeOnClickModal="false"
      :title="$t('header.changePassword')"
      :visible.sync="dialogPwdVisible"
      width="400px">
      <el-form label-position="right"
        label-width="80px"
        :model="pwdInfo"
        ref="pwdForm"
        :rules="pwdRule">
        <el-form-item :label="$t('header.oldPassword')"
          prop="oldPassword"
          :inline-message="true">
          <el-input v-model="pwdInfo.oldPassword"
            type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.newPassword')"
          prop="newPassword"
          :inline-message="true">
          <el-input v-model="pwdInfo.newPassword"
            type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.confirmPassword')"
          prop="confirmPassword"
          :inline-message="true">
          <el-input v-model="pwdInfo.confirmPassword"
            type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="dialogPwdVisible=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
          @click="confirmChangePwd">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CookieHelper from '@/utils/cookieHelper'
import LoginBiz from '@/logic/loginBiz'
import HeaderBiz from '@/logic/headerBiz'
import MD5 from 'md5'
export default {
  name: 'appHeader',
  data() {
    let checkNewPwd = pwd => {
      let vs = true
      let regArr = [/^[\u0021-\u007e]{8,20}$/, /[0-9]/, /[a-z]/, /[A-Z]/, /\W/]
      for (let i = 0; i < regArr.length; i++) {
        if (!regArr[i].test(pwd)) {
          vs = false
          break
        }
      }
      return vs
    }
    let oldPasswordRule = (rule, value, callback) => {
      if (!checkNewPwd(value)) {
        callback(new Error(this.$t('header.checkPwd')))
      } else {
        callback()
      }
    }
    let newPasswordRule = (rule, value, callback) => {
      if (!checkNewPwd(value)) {
        callback(new Error(this.$t('header.checkPwd')))
      } else {
        if (this.pwdInfo.newPassword !== '') {
          this.$refs.pwdForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    let confirmPasswordRule = (rule, value, callback) => {
      if (!checkNewPwd(value)) {
        callback(new Error(this.$t('header.checkPwd')))
      } else if (value !== this.pwdInfo.newPassword) {
        callback(new Error(this.$t('header.passSameAlert')))
      } else {
        callback()
      }
    }
    return {
      userName: '',
      langVis: false,
      langType: '简体中文',
      dialogVisible: false,
      dialogPwdVisible: false,
      userInfoVisible: false,
      userInfo: {
        userName: '',
        realName: '',
        phoneNum: '',
        email: ''
      },
      pwdInfo: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      userInfoRule: {
        realName: [
          { required: true, message: this.$t('header.realNameAlert') }
        ],
        phoneNum: [
          { required: true, message: this.$t('header.phoneNumAlert') },
          { type: 'number', message: this.$t('header.phoneCorrect') }
        ],
        email: [
          {
            required: true,
            message: this.$t('header.emailAlert'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('header.emailCorrect'),
            trigger: ['blur', 'change']
          }
        ]
      },
      pwdRule: {
        oldPassword: [
          { required: true, message: this.$t('header.oldPasswordAlert') },
          { validator: oldPasswordRule }
        ],
        newPassword: [
          { required: true, message: this.$t('header.newPasswordAlert') },
          { validator: newPasswordRule }
        ],
        confirmPassword: [
          { required: true, message: this.$t('header.confirmPasswordAlert') },
          { validator: confirmPasswordRule }
        ]
      }
    }
  },
  methods: {
    handlerUserInfo() {
      HeaderBiz.getUserInfo().then(data => {
        for (let i in this.userInfo) {
          this.userInfo[i] = data[i]
        }
        this.userInfo['phoneNum'] = Number(this.userInfo['phoneNum'])
        this.dialogVisible = true
      })
    },
    handlerPwdInfo() {
      this.dialogPwdVisible = true
      this.pwdInfo.oldPassword = ''
      this.pwdInfo.newPassword = ''
      this.pwdInfo.confirmPassword = ''
      this.$nextTick(() => {
        this.$refs['pwdForm'].clearValidate()
      })
    },
    confirmChange() {
      this.$refs['userInfoForm'].validate(valid => {
        if (valid) {
          let obj = { ...this.userInfo }
          HeaderBiz.updateUserInfo(obj).then(() => {
            this.dialogVisible = false
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
          })
        } else {
          return false
        }
      })
    },
    confirmChangePwd() {
      this.$refs['pwdForm'].validate(valid => {
        if (valid) {
          let obj = { ...this.pwdInfo }
          delete obj.confirmPassword
          obj.oldPassword = MD5(obj.oldPassword)
          obj.newPassword = MD5(obj.newPassword)
          HeaderBiz.updatePassword(obj).then(() => {
            this.dialogPwdVisible = false
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
          })
        } else {
          return false
        }
      })
    },
    logout() {
      LoginBiz.logout().then(() => {
        this.$router.push({ name: 'Login' })
      })
    },
    setLangType(type, init = false) {
      localStorage.setItem('language', type === 'zh' ? 'zh-CN' : 'en-US')
      if (init) return
      location.reload()
    }
  },
  created() {
    const cookieHelper = CookieHelper.getInstance()
    this.userName = cookieHelper.getCookie('username')
    if (!localStorage.getItem('language')) this.setLangType('zh', true)
    this.$i18n.locale =
      localStorage.getItem('language') === 'zh-CN' ? 'zh' : 'en'
    this.langType = this.$i18n.locale === 'zh' ? '简体中文' : 'English'
  }
}
</script>

<style scoped>
.uke-logo {
  position: relative;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.app-header {
  background: #252c4a;
  height: 50px;
}
.app-header .user-info-wrap {
  position: relative;
  float: right;
  cursor: pointer;
  text-align: center;
  color: #fff;
  width: 150px;
  height: 50px;
  line-height: 50px;
  transition: all 0.3s;
}
.app-header .user-info-wrap:hover {
  background: #3385ff;
}
.app-header .user-info {
  width: 150px;
  height: 150px;
  background: #252c4a;
  position: absolute;
  right: 0;
  z-index: 100;
  font-size: 14px;
  padding: 5px 0;
}
.app-header .lang-info {
  width: 150px;
  background: #252c4a;
  position: absolute;
  right: 0;
  z-index: 100;
  font-size: 14px;
  padding: 5px 0;
}
.user-info-each {
  height: 50px;
  transition: all 0.3s;
}
.user-info-each:hover {
  background: #3385ff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>